import * as formsConstants from './forms.constants';

export const getRegistrationFormFields = (state) => state.getIn([formsConstants.FORMS, formsConstants.REGISTRATION_FORM_FIELDS]);
export const getRegistrationFormFieldsFetchedFlag = (state) => state.getIn([formsConstants.FORMS, formsConstants.REGISTRATION_FORM_FIELDS_FETCHED]);
export const getFormsList = (state) => state.getIn([formsConstants.FORMS, formsConstants.FORMS_LIST]);
export const getFormsListFetchedFlag = (state) => state.getIn([formsConstants.FORMS, formsConstants.FORMS_LIST_LOADED]);
